// extracted by mini-css-extract-plugin
export default {"total":"ClansRatingSearchResult_total_dead9","totalValue":"ClansRatingSearchResult_totalValue_eefd8","spinner":"ClansRatingSearchResult_spinner_e2f40"};